module.exports = __webpack_public_path__ + "static/media/picture-(102).97cbca98.JPG";